const apiUrl = process.env.REACT_APP_API_URL;

export const PostImportUsers = async (idAula: string | number, formData: FormData) => {
    try {
        const response = await fetch(`${apiUrl}:8061/aules/${idAula}/import`, {
            method: 'POST',
            body: formData
        });
        return response.ok;
    } catch (error) {
        console.error('Error importing users:', error);
        return false;
    }
};
